export const navigation = [
    {
        name: 'MENU.DASHBOARD',
        url: '/dashboard',
        icon: 'icon-home',
        permission: ['dashboard.view'],
    },
    {
        name: 'MENU.USERS',
        icon: 'icon-people',
        permission: ['user.view', 'distributor.view', 'installer.view', 'client.view'],
        children: [
            {
                name: 'MENU.ADMIN',
                url: '/users',
                permission: ['user.view'],
            },
            {
                name: 'MENU.DISTRIBUTORS',
                url: '/distributors',
                permission: ['distributor.view'],
            },
            {
                name: 'MENU.INSTALLERS',
                url: '/installers',
                permission: ['installer.view'],
            },
            {
                name: 'MENU.CLIENTS',
                url: '/clients',
                permission: ['client.view'],
            },
        ]
    },
    {
        name: 'MENU.PLANT_LIST',
        url: '/plant_lists',
        icon: 'icon-list',
        permission: ['plant.view'],
    },
    {
        name: 'MENU.DEVICE_MONITORING',
        url: '/device_monitoring',
        icon: 'icon-list',
        permission: ['plant.view'],
    },
    {
        name: 'MQTT.REMOTE_CONTROL',
        icon: 'icon-list',
        permission: ['mqtt.view'],
        children: [
            {
                name: 'MQTT.VIEW_MQTT_COMMANDS',
                url: '/mqtt/commands_list',
                permission: ['mqtt.commands_list'],
            },
            {
                name: 'MQTT.SEND_MQTT_COMMANDS',
                url: '/mqtt/send_commands',
                permission: ['mqtt.send_commands'],
            }
        ]
    },
    {
        name: 'MENU.SETTING',
        icon: 'icon-settings',
        permission: ['permission.view'],
        children: [
            {
                name: 'MENU.PERMISSON_CATEGORY',
                //                icon: 'icon-user',
                url: '/setting/permission_categorys',
                permission: ['permission_category.view'],
            },
            {
                name: 'MENU.PERMISSION',
                //                icon: 'icon-user',
                url: '/setting/permissions',
                permission: ['permission.view'],
            },
            {
                name: 'MENU.ROLE',
                //                icon: 'icon-user',
                url: '/setting/roles',
                permission: ['role.view'],
            },
            {
                name: 'MENU.ALARM_CODE',
                //                icon: 'icon-user',
                url: '/alarm_codes',
                permission: ['alarm_code.view'],
            },
        ]
    },

];



// WEBPACK FOOTER //
// /var/www/delios/delios-live/app/src/app/_nav.ts